var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"forgot"},[_c('form',[_c('img',{staticClass:"img_glow_left",attrs:{"src":"/static/images/home/glow.png"}}),_vm._v(" "),_vm._t("main")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4019c44c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/visitor/forgotPassword/ForgotPasswordLayout.vue
// module id = null
// module chunks = 